import * as React from 'react';
import AuditCore from '../AfrCore/AuditCore';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import { setIsDirty, isAdmin } from '../../redux/MiscSlice';

const AuditA = (props: any) => {
    const isAdminUser: boolean = useAppSelector(isAdmin);

    return (
        <React.Fragment>
            <AuditCore userRole={isAdminUser ? "ADMIN" : "USER"} />
        </React.Fragment>
    );
}

export default AuditA;